<!-- Показывает параметры и порядок подключения выбранного протокола трекера -->
<template>
  <section v-if="protocol" class="protocol-info">
    <div class="protocol-info__content">
      <h4 class="protocol-info__title">Как подключить</h4>

      <ol class="protocol-info__steps">
        <li v-for="(step, index) in protocol.steps" :key="step">
          <span class="protocol-info__step-number">
            {{ index + 1 }}
          </span>
          <span>{{ step }}</span>
        </li>
      </ol>

      <span class="protocol-info__label">Адрес и порт</span>
      <BaseCode
        class="protocol-info__endpoint"
        :value="endpoint"
        copy-title="Скопировать адрес и порт"
      />
    </div>
  </section>
</template>

<script>
export default {
  name: "TrackerProtocolInfo",

  props: {
    protocol: {
      type: Object,
      default: null,
    },
  },

  computed: {
    endpoint() {
      return this.protocol.endpoint;
    },
  },
};
</script>

<style scoped>
.protocol-info {
  margin-bottom: var(--base-in-indent);
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fafbfc;
  color: var(--color-dark);
}

.protocol-info__title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
}

.protocol-info__label {
  display: block;
  margin-top: 12px;
  color: #6b7280;
  font-size: 11px;
  font-weight: 500;
}

.protocol-info__content {
  padding: 12px;
}

.protocol-info__endpoint {
  max-width: 100%;
  margin-top: 5px;
}

.protocol-info__steps {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 8px 0 0;
  padding: 0;
  list-style: none;
  color: #4b5563;
  font-size: 12px;
  line-height: 1.35;
}

.protocol-info__steps li {
  display: flex;
  align-items: flex-start;
  gap: 7px;
}

.protocol-info__step-number {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 17px;
  height: 17px;
  border-radius: 50%;
  background: #eef2f7;
  color: #667085;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
}

</style>
